import React from 'react';
import PropType from 'prop-types';

export const FixtureWatermarks = ({ home, away }) => {
    const homeTeamAbbr = PULSE.app.common.team.getTeamAbbr(home.providerId);
    const awayTeamAbbr = PULSE.app.common.team.getTeamAbbr(away.providerId);

    const homePrefix = PULSE.app.common.team
        .getAFLWSpecificIcons()
        .includes(home.providerId)
        ? 'aflw-'
        : '';

    const awayPrefix = PULSE.app.common.team
        .getAFLWSpecificIcons()
        .includes(away.providerId)
        ? 'aflw-'
        : '';

    return (
        <div className="fixtures__watermark-container">
            <div
                className={`fixtures__watermark fixtures__watermark--home fixtures__watermark--${homeTeamAbbr.toLowerCase()}`}
                style={{
                    backgroundImage: `url('${PULSE.app.environment.watermarksPath}${homeTeamAbbr}-${homePrefix}left-colour.png')`
                }}
            />
            <div
                className={`fixtures__watermark fixtures__watermark--away fixtures__watermark--${awayTeamAbbr.toLowerCase()}`}
                style={{
                    backgroundImage: `url('${PULSE.app.environment.watermarksPath}${awayTeamAbbr}-${awayPrefix}right-colour.png')`
                }}
            />
        </div>
    );
};

FixtureWatermarks.propTypes = {
    home: PropType.object,
    away: PropType.object
};
